import * as React from 'react';
import IArchiveHistoryList from '../interfaces/IArchiveHistoryList';

class ArchiveHistory extends React.Component<{}, IArchiveHistoryList> {
    constructor(props: {}) {
        super(props);
        this.state = {
            archiveHistory: [],
            archiveSearch: [],
            searchTerm: '',
            errors: []
        };
    }

    componentWillMount() {
        this.retrieveDocumentList();
    }

    private downloadFile(externalFileId: string) {
        // The endpoint URL where the server serves the CSV file
        let url = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_API_URL_DEV : process.env.REACT_APP_API_URL_PROD;
        // fetch(`${url}api/blacklist/documentList`)
        const endpointUrl = `${url}api/blacklist/document/${externalFileId}`;
        // Use fetch API to request the file from the server
        fetch(endpointUrl)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to download the file.');
                }
                return response.blob(); // Convert the response to a Blob
            })
            .then(blob => {
                // Create a temporary URL for the file
                const url = window.URL.createObjectURL(blob);

                // Create a link element
                const a = document.createElement('a');
                a.href = url;

                // Use the filename you set on the server-side
                a.download = `${externalFileId}.csv`;

                // Append the link to the document and simulate a click
                document.body.appendChild(a);
                a.click();

                // Clean up by revoking the URL and removing the link
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            })
            .catch(error => console.error('Error downloading file:', error));

    }

    private retrieveDocumentList() {
        let url = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_API_URL_DEV : process.env.REACT_APP_API_URL_PROD;
        fetch(`${url}api/blacklist/documentList`)
            .then(res => {
                if (res.status === 200) {
                    res.json().then(data => {
                        const result = [];
                        const map = new Map();
                        for (const item of data) {
                            if (!map.has(item.searchDetails)) {
                                map.set(item.searchDetails, true);
                                result.push({
                                    searchDetails: `${item.searchDetails.substr(0, 50)}...`,
                                    externalFileId: item.externalFileId
                                });
                            }
                        }
                        this.setState({ archiveHistory: result })
                    });
                }
                else if (res.status !== 200) {
                    res.json().then(data => {
                        if (Array.isArray(data.details)) {
                            this.setState({ errors: data.details });
                        }
                        else {
                            this.setState({ errors: [data.details] });
                        }
                    });
                }
            })
    }

    private renderTable(items: Array<any>) {

        const notResults = (<div>No se encontraron resultados </div>)

        return (
            items.length > 0 ?
                items.map(item =>
                (<div key={item.externalFileId}>
                    <a href={`api/blacklist/document/${item.externalFileId}`}
                        onClick={(e) => { e.preventDefault(); this.downloadFile(item.externalFileId); }}>
                        {item.searchDetails}
                    </a>
                </div>)
                )
                :
                notResults
        );
    }

    private handleSubmit(event: any) {
        event.preventDefault();
    }

    render() {
        return (
            <div className="container">
                <h1>Hist&oacute;rico de archivos del SAT</h1>
                <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                        <input type="text" className="form-control mb-2 mr-sm-2" placeholder="Búsqueda"
                            value={this.state.searchTerm}
                            onChange={
                                (e: React.FormEvent<HTMLInputElement>) =>
                                    this.setState({
                                        searchTerm: e.currentTarget.value.toUpperCase(),
                                        archiveSearch: this.state.archiveHistory.filter((item) => { return item.searchDetails.toUpperCase().includes(e.currentTarget.value.toUpperCase()) })
                                    })} />
                    </div>
                </form>
                {(this.state.archiveSearch.length > 0 || this.state.searchTerm.length > 0) ? this.renderTable(this.state.archiveSearch) : this.renderTable(this.state.archiveHistory)}
            </div>
        );
    }
}

export default ArchiveHistory;